import React from 'react'
import './Services.css'

import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import Card from '../Card/Card';
import Resume from './resume.pdf';
import { themeContext } from '../../Context'
import { useContext } from 'react'
import {motion} from 'framer-motion'

const Services = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode
    const transition = {duration : 2, type : 'spring'}

    return(
        <div className="services" id="Services">
            {/* left side */}
            <div className="awesome">
                <span style={{color: darkMode? 'white': ''}}>My Awesome</span>
                <span>services</span>
                <span style={{color: darkMode? 'white': ''}}>
                    Motivated web developer looking for a role as web developer.
                    <br />
                    Passionate about building amazing applications.
                </span>
                <a href={Resume} download>
                <button className="button s-button">Download CV</button>
                </a>
                <div className="blur s-blur1"></div>
            </div>

            {/* right side */}
            <div className="cards">
                <motion.div 
                initial ={{left: '20rem'}}
                whileInView = {{left: '24rem'}}
                transition = {transition}

                className="card-child-1">
                    <Card
                        emoji = {HeartEmoji}
                        heading = {'Design'}
                        detail = {"Photoshop, Adobe"}
                    />
                </motion.div>
                <motion.div 
                initial ={{left: '0rem', top : '8rem'}}
                whileInView = {{left: '2rem', top : '12rem'}}
                transition = {transition}

                className="card-child-2">
                    <Card
                        emoji = {Glasses}
                        heading = {'Developer'}
                        detail = {"Html, CSS, Javascript, Bootstrap,  React, Django, MySql, Mongo DB"}
                    />
                </motion.div>
                <motion.div
                initial ={{left: '24rem', top : '15rem'}}
                whileInView = {{left: '18rem', top : '20rem'}}
                transition = {transition}

                className="card-child-3">
                    <Card
                        emoji = {Humble}
                        heading = {'Problem Solver'}
                        detail = {"C, C++, Python, DSA"}
                    />
                </motion.div>
                <div className="blur s-blur2"></div>
            </div>
        </div>
    )
}

export default Services